import React from "react";

import classnames from "classnames/bind";
import styles from "./XYChartTooltip.module.scss";

import { CircleIcon, LineIcon, SquareIcon } from "../../components/Icons";

import type { XYChartTooltipProps } from "../types";

const cx = classnames.bind(styles);

const XYChartTooltip = ({ date, items }: XYChartTooltipProps) => {
  return (
    <div className={cx("tooltipContainer")}>
      <p className={cx("date")}>{date}</p>

      <ul className={cx("list")}>
        {items.map(({ value, variant, colour, label }) => (
          <li
            key={value}
            className={cx("item")}
          >
            <div>
              <svg
                width={variant === "bar" ? 12 : 20}
                height={12}
                className={cx("indicator")}
              >
                {variant === "bar" ? <SquareIcon fill={colour} /> : null}

                {variant === "scatter-plot" ? (
                  <CircleIcon fill={colour} />
                ) : null}

                {variant === "line" ? <LineIcon stroke={colour} /> : null}
              </svg>

              {label}
            </div>

            <span className={cx("value")}>{value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default XYChartTooltip;
